// extracted by mini-css-extract-plugin
export default {"thankyouSection":"Thankyou_thankyouSection__O1TdJ","thankyouContainerSection":"Thankyou_thankyouContainerSection__w273x"};